/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProviderSummary } from './resourceProviderSummary';
import { ResourceCategory } from './resourceCategory';


export interface ResourceProviderCategorySummary { 
    category?: ResourceCategory;
    summary?: ResourceProviderSummary;
}
export namespace ResourceProviderCategorySummary {
}


